module.exports = __webpack_public_path__ + "img/money.e447ee18.svg";